import { FC, PropsWithChildren } from "react";

export type PageLayoutProps = PropsWithChildren;

export const PageLayout: FC<PageLayoutProps> = ({ children }) => (
  <main className="my-12 mx-auto px-4 md:px-12 lg:px-16 xl:max-w-[1280px] flex flex-col gap-8">
    {children}
  </main>
);
